import { useStoreActions } from '~/contexts';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { QueryKeys } from '../queryKeys';
const EMPTY_CONTACTS = [];
export const useContacts = function useContacts() {
    let { refreshOnMount = false, withLoader = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { data: contacts, isLoading, isFetching, refresh, isBackgroundLoading, optimisticUpdate, error, dataUpdatedAt } = useQueryState({
        queryKey: [
            QueryKeys.Contacts
        ],
        queryFn: async ()=>api.contact.getAll(),
        refreshOnHookMount: refreshOnMount,
        withLoader
    });
    return {
        contacts: contacts !== null && contacts !== void 0 ? contacts : EMPTY_CONTACTS,
        isFetching,
        isLoading,
        refresh,
        isBackgroundLoading,
        optimisticUpdate,
        error,
        dataUpdatedAt
    };
};
